export const USER_ROLE_ID = Object.freeze({
  CONTENT_ROLE: 7,
});
